import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import $ from 'jquery';
import classnames from 'classnames';

const GLOBAL = require('../../Globals');

class Bank extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			bank : '',
			_message : '',
			alertClass :'',
			design : [],
			empname : [],
			banks : [],
			desig : '',
			employee : '',
			bankname : '',
			branch : '',
			bankaddr : '',
			email : '',
			mobile : '',
			ifsc : '',
			accno : '',
			payaddr : '',
			posts : [],
			data : [],
			activeTab: '1'
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onDetSubmit = this.onDetSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onDelClick = this.onDelClick.bind(this);
		this.handleDetClick = this.handleDetClick.bind(this);
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** reset Bank form **/
	onClick(e){
		
		document.getElementById("suballform").reset();
	}
	
	/** reset BAnk Detail form **/
	onDelClick(e){
		
		document.getElementById("bankdetform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onDetSubmit(e){
		
		e.preventDefault();
		
		if(this.state.desig && this.state.employee && this.state.bankname && this.state.branch && this.state.bankaddr && this.state.email && this.state.mobile && this.state.ifsc && this.state.accno && this.state.payaddr){
			$("#showLoader").show();
			
			PostData('bank/addbankdetails',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Bank Details Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("bankdetform").reset();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.bank){
			$("#showLoader").show();
			PostData('bank/add',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Bank Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("userform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			PostData('bank/deletebank',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Bank Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Bank',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	handleDetClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			PostData('bank/deletebankdet',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Bank Details Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getbankdetail();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Bank',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdesignation();
		this.getemployee();
		this.getbank();
		this.getdata();
		this.getbankdetail();
	}
	
	getbankdetail(){
		
		GetData('bank/getbankdetails').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	getdata(){
		
		GetData('bank/getbank').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Bank **/
	getbank(){
		$("#showLoader").show();
		GetData('bank/getbank').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					banks : responseJson
				});
			}
		});
	}
	
	/** get Designation **/
	getdesignation(){
		
		GetData('designation/getdesignation').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					design : responseJson
				});
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		
		GetData('employee/getemployee').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					empname : responseJson
				});
			}
		});
	}
	
	
  render() {
	
	var desi = this.state.design;
	var emp = this.state.empname;
	var ban = this.state.banks;
	   
	    /** get Section By Class **/
	$("#design").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'employee/getemployeebydesi/'+fr,function(o){
			$("#showLoader").hide();
			//$("#acHead").removeClass('chosen_a');
			$("#empl").html('');
			$('#empl')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Employee- ')); 
			$.each(o,function(key,value){			
				   $('#empl')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.empname)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
  
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
         <Row>
          <Col md="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                  Bank
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  Bank Details
                </NavLink>
              </NavItem>
			  <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '3' })}
                  onClick={() => { this.toggle('3'); }}
                >
                  List
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
				<Row>
				<Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Add Bank</strong>
					</CardHeader>
					<CardBody>
					  <Row>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Bank <span className="text-danger">*</span></Label>
								<Input type="text" name="bank" required placeholder="Enter Bank Name" onChange={this.onChange} />
							</FormGroup>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
				</Col>
				<Col md="6">
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Bank Name</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.bank}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
				</Col>
				</Row>
			  </TabPane>
			  <TabPane tabId="2">
				<Row>
				<Col md="12">
				  <Card>
					<form action="" method="post" role="form" id="bankdetform" encType="multipart/form-data" onSubmit={this.onDetSubmit} >
					  <CardHeader>
						<strong>Bank Details</strong>
					  </CardHeader>
					  <CardBody>
						<Row>
						  <Col md="6">
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Designation <span className="text-danger">*</span></Label>
									<select name="desig" onChange={this.onChange} className="form-control" required id="design" >
										<option value="">Select Designation</option>
										{
											desi.map(function (item) {
												return <option value={item.id }>{item.designation}</option>;
											})
										}
									</select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Employee Name <span className="text-danger">*</span></Label>
									<select name="employee" onChange={this.onChange} className="form-control" required id="empl" >
																	
									</select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Bank Name <span className="text-danger">*</span></Label>
									<select name="bankname" onChange={this.onChange} className="form-control" required>
										<option value="">Select Bank</option>
										{
											ban.map(function (item) {
												return <option value={item.id }>{item.bank}</option>;
											})
										}
									</select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Branch  <span className="text-danger">*</span></Label>
									<Input type="text" name="branch" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Bank Address <span className="text-danger">*</span></Label>
									<Input type="textarea" name="bankaddr" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						  </Col>
						  <Col md="6">
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Email  <span className="text-danger">*</span></Label>
									<Input type="email" name="email" required onChange={this.onChange} />
								</FormGroup>
							</Col>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Mobile  <span className="text-danger">*</span></Label>
									<Input type="number" name="mobile" required onChange={this.onChange} />
								</FormGroup>
							</Col>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">IFSC Code  <span className="text-danger">*</span></Label>
									<Input type="text" name="ifsc" required onChange={this.onChange} />
								</FormGroup>
							</Col>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Account No  <span className="text-danger">*</span></Label>
									<Input type="number" name="accno" required onChange={this.onChange} />
								</FormGroup>
							</Col>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">DD Payable Address  <span className="text-danger">*</span></Label>
									<Input type="textarea" name="payaddr" required onChange={this.onChange} />
								</FormGroup>
							</Col>
						  </Col>
						</Row>
					  </CardBody>
					  <CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onDelClick}><i className="fa fa-ban"></i> Reset</Button>
					  </CardFooter>
					</form>
				  </Card>
				</Col>
				</Row>
			  </TabPane>
			  <TabPane tabId="3">
				<Row>
				<Col md="12">
				 <Card>
				   <CardHeader>
					<strong>Bank Detail List</strong>
				   </CardHeader>
				   <CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Employee Code</th>
								<th>Employee Name</th>
								<th>Bank</th>
								<th>Branch</th>
								<th>Account No.</th>
								<th>IFSC Code</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.empcode}</td>
									<td>{item.empname}</td>
									<td>{item.bank}</td>
									<td>{item.branch}</td>
									<td>{item.accno}</td>
									<td>{item.ifsc}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleDetClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
				  </CardBody>
				 </Card>
				</Col>
				</Row>
			  </TabPane>
			</TabContent>
		  </Col>
		 </Row>
		</div>
	);
  }
}

export default Bank;


// WEBPACK FOOTER //
// ./src/employee/Bank/Bank.js